module.exports = __webpack_public_path__ + "static/img/lhgzh.c9cdcb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lhgzh.jpg
// module id = qwnq
// module chunks = 15